import React, { useEffect, useState } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { Button, Form, Input, FormFeedback, Label, Row, Col } from 'reactstrap'
import Select from 'react-select'
import { ArrowLeft, ArrowRight } from 'react-feather'
import { useOnboarding } from '../OnboardingContext'
import { selectThemeColors } from '@utils'
import { languageOptions } from '../Options'
import { useTranslation } from 'react-i18next'

function AddUsers({ stepper }) {
  const { language, dateFormat, numberFormat, collaborators, setCollaborators, updateLatestStep } = useOnboarding()
  const [buttonText, setButtonText] = useState('Skip')
  const { t } = useTranslation()

  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm({collaborators})

  const onSubmit = () => {
    const filledUsers = collaborators.filter(u => u.firstName && u.lastName && u.email)
    const filledUsersWithLanguage = filledUsers.map(user => ({
      firstname: user.firstName,
      lastname: user.lastName,
      email: user.email,
      language: user.language || language,
      dateformat: dateFormat,
      numberformat: numberFormat
    }))
    setCollaborators(filledUsersWithLanguage)
    updateLatestStep(5)
    stepper.next()
  }

  useEffect(() => {
    const filledUsers = collaborators.filter(u => u.firstName && u.lastName && u.email)
    if (filledUsers.length > 0) {
      setButtonText(t('next'))
    } else {
      setButtonText(t('skip'))
    }
  }, [collaborators])

  return (
    <div>
      <div className='content-header'>
        <h5 className='mb-0'>{t('users-title')}</h5>
        <small>{t('users-subtitle')}</small>
      </div>
      <Form onSubmit={handleSubmit(onSubmit)}>
        {collaborators.map((user, index) => (
          <Row key={index}>
            <Col md='3' className='mb-1'>
              <Label className='form-label' for={`firstName${index}`}>
              {t('firstname')}
              </Label>
              <Controller
                id={`firstName${index}`}
                name={`firstName${index}`}
                control={control}
                render={({ field }) => (
                  <Input
                    placeholder={t('firstname')}
                    invalid={errors[`firstName${index}`] && true}
                    {...field}
                    onChange={(e) => {
                      const newUsers = [...collaborators]
                      newUsers[index].firstName = e.target.value
                      setCollaborators(newUsers)
                      field.onChange(e)
                    }}
                  />
                )}
              />
              {errors[`firstName${index}`] && (
                <FormFeedback>{errors[`firstName${index}`].message}</FormFeedback>
              )}
            </Col>
            <Col md='3' className='mb-1'>
              <Label className='form-label' for={`lastName${index}`}>
              {t('lastname')}
              </Label>
              <Controller
                id={`lastName${index}`}
                name={`lastName${index}`}
                control={control}
                render={({ field }) => (
                  <Input
                    placeholder={t('lastname')}
                    invalid={errors[`lastName${index}`] && true}
                    {...field}
                    onChange={(e) => {
                      const newUsers = [...collaborators]
                      newUsers[index].lastName = e.target.value
                      setCollaborators(newUsers)
                      field.onChange(e)
                    }}
                  />
                )}
              />
              {errors[`lastName${index}`] && (
                <FormFeedback>{errors[`lastName${index}`].message}</FormFeedback>
              )}
            </Col>
            <Col md='3' className='mb-1'>
              <Label className='form-label' for={`email${index}`}>
              {t('email')}
              </Label>
              <Controller
                id={`email${index}`}
                name={`email${index}`}
                control={control}
                render={({ field }) => (
                  <Input
                    type='email'
                    placeholder='john.doe@gmail.com'
                    invalid={errors[`email${index}`] && true}
                    {...field}
                    onChange={(e) => {
                      const newUsers = [...collaborators]
                      newUsers[index].email = e.target.value
                      setCollaborators(newUsers)
                      field.onChange(e)
                    }}
                  />
                )}
              />
              {errors[`email${index}`] && (
                <FormFeedback>{errors[`email${index}`].message}</FormFeedback>
              )}
            </Col>
            <Col md='3' className='mb-1'>
              <Label className='form-label' for={`language${index}`}>
              {t('language')}
              </Label>
              <Controller
                id={`language${index}`}
                name={`language${index}`}
                control={control}
                render={({ field }) => (
                  <Select
                    isClearable={false}
                    theme={selectThemeColors}
                    id={`language${index}`}
                    options={languageOptions}
                    className='react-select'
                    classNamePrefix='select'
                    {...field}
                    value={languageOptions.find((option) => option.value === (collaborators[index].language ? collaborators[index].language : language))}
                    onChange={(e) => {
                      const newUsers = [...collaborators]
                      newUsers[index].language = e.value
                      setCollaborators(newUsers)
                      field.onChange(e)
                    }}
                  />
                )}
              />
            </Col>
          </Row>
        ))}
        <div className='d-flex justify-content-between'>
          <Button type='button' color='primary' className='btn-prev' onClick={() => stepper.previous()}>
            <ArrowLeft size={14} className='align-middle me-sm-25 me-0' />
            <span className='align-middle d-sm-inline-block d-none'>{t('previous')}</span>
          </Button>
          <Button type='submit' color='primary' className='btn-next'>
            <span className='align-middle d-sm-inline-block d-none'>{buttonText}</span>
            <ArrowRight size={14} className='align-middle ms-sm-25 ms-0' />
          </Button>
        </div>
      </Form>
    </div>
  )
}

export default AddUsers
